import { render, staticRenderFns } from "./price-computer.vue?vue&type=template&id=1cdd0f58&scoped=true&"
import script from "./price-computer.vue?vue&type=script&lang=js&"
export * from "./price-computer.vue?vue&type=script&lang=js&"
import style0 from "./price-computer.vue?vue&type=style&index=0&id=1cdd0f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd0f58",
  null
  
)

export default component.exports